import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";


import PersonIcon from '@mui/icons-material/Person';
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import SchoolIcon from '@mui/icons-material/School';
import LogoutIcon from '@mui/icons-material/Logout';
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from '../../AuthContext.js';
import { useNavigate } from "react-router-dom";


import DashboardIcon from '@mui/icons-material/Dashboard';
import './navbar.css';
import axiosInstance from "../../axiosInstance.js";
const Navbar1 =()=>{
  const [userRole, setUserRole] = useState(null);

  const { isAuthenticated,setIsAuthenticated,setUser,isCollapsed,setIsCollapsed } = useAuth();
  

  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user"));

  const BASE_URL = process.env.REACT_APP_BASE_URL;

    useEffect(() => {
        
        if (user) {
            setUserRole((user.role)); 
        }
    }, []);

    const logOut = () =>{
        

        axiosInstance.post(`/api/out?teacherId=${user.id}`).then((res)=>{
            setIsAuthenticated(false); 
          }).catch((e)=>{
           
          //  window.location.reload();
        
          }).finally(()=>{
               localStorage.removeItem("user");
            localStorage.removeItem("jwtToken");
            navigate("/login");
            window.location.reload();
          })

    }


    const rolePermissions = {
        ADMIN: ["dashboard", "profile", "request", "teacher", "students", "bill", "competition", "stock"],
        TEACHER: ["dashboard", "profile", "students", "competition","request"],
        STUDENT: ["dashboard", "profile", "request"],
    };

    const hasAccess = (menuKey) => {
        return rolePermissions[userRole]?.includes(menuKey);
    };


    return (
        
      <div className="sidebar_container">
     <Sidebar className="menu-items" collapsed ={isCollapsed}
     >
        <Menu >

             <div className="menu-toggle">
                    <MenuItem
                        icon={<MenuOutlinedIcon />}
                        onClick={() => setIsCollapsed(!isCollapsed)}
                         style={{ height: "49px", marginBottom: "10px" }}
                    >
                        <img src="./evr.png" style={{ height: "40px", marginTop: "28px" }} alt="Logo" />
                    </MenuItem>

            </div>

        



            {hasAccess("dashboard") && (
                <MenuItem icon={<DashboardIcon />} component={<Link to="/dashboard" />}>Dashboard</MenuItem>
            )}
            {hasAccess("profile") && (
                <MenuItem icon={<HomeOutlinedIcon />} component={<Link to="/profile" />}>My Profile</MenuItem>
            )}
            {/* {hasAccess("request") && (
                <MenuItem icon={<MarkUnreadChatAltIcon />} component={<Link to="/request" />}>Requests</MenuItem>
            )} */}
            {hasAccess("teacher") && (
                <MenuItem icon={<PersonIcon />} component={<Link to="/teacher" />}>Teacher</MenuItem>
            )}
            {hasAccess("students") && (
                <MenuItem icon={<SchoolIcon />} component={<Link to="/students" />}>Student</MenuItem>
            )}
            {/* {hasAccess("bill") && (
                <MenuItem icon={<AttachMoneyIcon />}>Bill</MenuItem>
            )}
            {hasAccess("competition") && (
                <MenuItem icon={<AssignmentIcon />}>Competition</MenuItem>
            )}
            {hasAccess("stock") && (
                <MenuItem icon={<LibraryBooksIcon />}>Stock</MenuItem>
            )} */}

            <MenuItem icon={<LogoutIcon />} onClick={logOut}>Log out</MenuItem>
        
    
        </Menu>
      </Sidebar>
      </div>

    
        
    )
}


export default Navbar1;



